import { Animation, createAnimation } from '@ionic/angular';

export function myLeaveAnimation(baseEl: HTMLElement): Animation {

    const baseAnimation = createAnimation();

    const backdropAnimation = createAnimation();
    backdropAnimation.addElement(baseEl.querySelector('ion-backdrop'));

    const wrapperAnimation = createAnimation();
    const wrapperEl = baseEl.querySelector('.modal-wrapper');
    wrapperAnimation.addElement(wrapperEl);

    wrapperAnimation
      .fromTo('transform', 'scaleX(1) scaleY(1)', 'scaleX(0.8) scaleY(0.8)')
      .fromTo('opacity', 1, 0);

    backdropAnimation.fromTo('opacity', 0.5, 0.0);

    return baseAnimation
      .addElement(baseEl)
      .easing('ease-in')
      .duration(100)
      .addAnimation([backdropAnimation, wrapperAnimation])

}